import React from "react";

import * as THREE from "three"

import { useObjectStore } from "../zustand/objects";
import { matrix4FromState } from "../utils/matrix4FromState";
import { ActionIcon, Group } from '@mantine/core';
import { IconRefresh, IconMinus, IconPlus } from '@tabler/icons-react';


const ChangeScaleLayerListButtons = ({matrix, id, currentObjectArtboard, borderColour, iconColour}) => {
    const {arrangeUndoRedo, updateObjectMatrix, projectKey} = useObjectStore()

    const ObjectUpdate = (val) => {
        // send current state to undoActions
        arrangeUndoRedo({
            updateType: "objectUpdate", 
            artboard: currentObjectArtboard, 
            objectID: id,
            undo:false, 
            projectKey: projectKey, 
            field: "matrixState",
            })
            // send update to zustand
        updateObjectMatrix({
          id,
          currentObjectArtboard,
          matrix: new THREE.Matrix4().copy(val),
          undo: false
        })
    }

function increaseSize(e) {
    const pos = new THREE.Vector3()
    const rot = new THREE.Quaternion()
    const sca = new THREE.Vector3()
    matrix4FromState(matrix).decompose(pos, rot, sca)
    if (e==='all') {ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x + 0.0625, sca.y + 0.0625, sca.z + 0.0625)))}
    if (e==='x') {ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x + 0.0625, sca.y, sca.z)))}
    if (e==='y') {ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x, sca.y + 0.0625, sca.z)))}
    if (e==='z') {ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x, sca.y, sca.z + 0.0625)))}
   }


    
    async function reduceSize(e) {
        const pos = new THREE.Vector3()
        const rot = new THREE.Quaternion()
        const sca = new THREE.Vector3()
        matrix4FromState(matrix).decompose(pos, rot, sca)
        if (e==='all') {ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x === 0.0625 ? 0.0625: sca.x - 0.0625, sca.y === 0.0625 ? 0.0625: sca.y - 0.0625,sca.z === 0.0625 ? 0.0625: sca.z - 0.0625)))}
        if (e==='x') {ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x === 0.0625 ? 0.0625: sca.x - 0.0625, sca.y, sca.z)))}
        if (e==='y') {sca.x >= 0.0625 && ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x, sca.y === 0.0625 ? 0.0625: sca.y - 0.0625, sca.z)))}
        if (e==='z') {sca.x >= 0.0625 && ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(sca.x, sca.y, sca.z === 0.0625 ? 0.0625: sca.z - 0.0625)))}
   }

   function resetSize(e) {
    const pos = new THREE.Vector3()
    const rot = new THREE.Quaternion()
    matrix4FromState(matrix).decompose(pos, rot, new THREE.Vector3())
    ObjectUpdate(new THREE.Matrix4().compose(pos, rot, new THREE.Vector3(1,1,1)))

   }

   const scaleMode = "all"

 
    return (
            <Group gap={5}>
            <ActionIcon onClick={() => resetSize()} size={'md'} variant="outline" aria-label="Settings" color={iconColour || borderColour} style={{ borderColor: borderColour }}>
                <IconRefresh style={{ width: '70%', height: '70%' }}  stroke={1.5} />
            </ActionIcon>
            <ActionIcon onClick={() => reduceSize(scaleMode )} size={'md'} variant="outline" aria-label="Settings" color={iconColour || borderColour} style={{ borderColor: borderColour }}>
                <IconMinus style={{ width: '70%', height: '70%'}} stroke={1.5} />
            </ActionIcon>
            <ActionIcon onClick={() => increaseSize(scaleMode)} size={'md'} variant="outline" aria-label="Settings" color={iconColour || borderColour} style={{ borderColor: borderColour }}>
                <IconPlus style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
            </Group>
    )
}

// need to change scale and then send it to function as part of a matrix4

export default ChangeScaleLayerListButtons
